/**
 * 邮件模块路由（保留 emptyRouterView）
 */
export default [
  {
    path: "/menu",
    component: resolve => require(["@/views/menu.vue"], resolve),
    redirect: "/menu/home",
    children: [
      {
        path: "market",
        component: resolve => require(["@/views/market/index.vue"], resolve),
        redirect: "/menu/market/email/list",
        children: [
          {
            path: "email",
            component: resolve => require(["@/views/market/EmptyRouterView.vue"], resolve),
            redirect: "/menu/market/email/list",
            children: [
              {
                path: "add1",
                component: resolve => require(["@/modules/email/pages/SimpleAdd.vue"], resolve),
                meta: { nameText: "新建邮件" }
              },
              {
                path: "add",
                component: resolve => require(["@/modules/email/pages/EmailAdd.vue"], resolve),
                meta: { nameText: "新建邮件" }
              },
              {
                path: "list",
                component: resolve => require(["@/modules/email/pages/list.vue"], resolve)
              },
              {
                path: "template",
                component: resolve => require(["@/modules/email/pages/template.vue"], resolve)
              },
              {
                path: "report/:id",
                component: resolve => require(["@/modules/email/pages/EmailReport.vue"], resolve),
                meta: { nameText: "邮件统计" }
              }
            ]
          }
        ]
      }
    ]
  }
];
